import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { AppButton } from "@/shared/Components";
import { TrashBinIcon } from "@/shared/icons";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  onClick: () => void;
  contactsPage?: boolean;
  disabled?: boolean;
};

export const DeleteNotesButton: FC<Props> = ({ onClick, disabled, contactsPage = false }) => {
  const { t } = useTranslation();

  return (
    <AppButton
      disabled={disabled}
      className={classNames(styles.root, { [styles["root--contacts"]]: contactsPage })}
      onClick={onClick}
    >
      <TrashBinIcon className={styles.icon} />
      <p>{t("common.deleteSelected")}</p>
    </AppButton>
  );
};
